// extracted by mini-css-extract-plugin
module.exports = {"blockWrapper":"Companies_blockWrapper__ue0_6","content":"Companies_content__epnlc"};